import styled from 'styled-components';

import { eyebrow, thinScrollbar } from '../../styles/mixins';

const Hero = styled.section`
  padding: 6.4rem 0 4.4rem;
  text-align: center;

  @media (max-width: 600px) {
    padding: 3.6rem 0 3rem;
  }
`;

const Eyebrow = styled.span`
  ${eyebrow}
  display: block;
`;

const HeroTitle = styled.h1`
  font-size: 5.2rem;
  line-height: 1.05;
  font-weight: 700;
  margin-top: 1.2rem;

  @media (max-width: 600px) {
    font-size: 3.4rem;
  }
`;

const HeroLead = styled.p`
  margin: 1.6rem auto 0;
  font-size: 1.7rem;
  line-height: 1.6;
  color: var(--ink-soft);
  max-width: 52ch;
`;

const Section = styled.section`
  padding: 3.6rem 0;

  @media (max-width: 600px) {
    padding: 2.4rem 0;
  }
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.2rem;

  @media (max-width: 1080px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.4rem;
  }
`;

const RankRail = styled.div`
  ${thinScrollbar}
  display: flex;
  gap: 1.8rem;
  overflow-x: auto;
  padding-bottom: 1rem;
  scroll-snap-type: x proximity;
`;

export { Eyebrow, Hero, HeroLead, HeroTitle, ProjectsGrid, RankRail, Section };
